import type { UnlikelyProduct, UnlikelyVariant } from '@unlikelystudio/commerce-connector'
import type { Nullish } from '~/@types/generics'
import { getMarket } from '~/lib/i18n/utils/get-i18n'
import { getProductMetafieldValue, getVariantMetafieldValue } from '~/lib/shopify/constants'
import { parseShopifyReferencesFromMetatield } from '~/lib/shopify/utils/parse-references-from-metafields'
import { parseTextsFromMetafield } from '~/lib/shopify/utils/parse-texts-from-metafields'

export function serializeVariants(
  product: Nullish<UnlikelyProduct>,
  variants: Nullish<UnlikelyVariant[]>,
  locale: Nullish<string>
) {
  if (!variants || variants.length === 0 || !product) {
    return []
  }

  // Hidden variants
  const hiddenVariantsForProduct = getProductMetafieldValue(product.metafields, "HIDE_VARIANTS_IN_SIMPLE_PRODUCTS")
  const hiddenVariants = parseShopifyReferencesFromMetatield(hiddenVariantsForProduct) ?? []
  const market = getMarket(locale)

  const serializedVariants = variants
    .map((variant) => {
      const hiddenOnMarket =
        parseTextsFromMetafield(getVariantMetafieldValue(variant.metafields, "HIDDEN_ON_MARKET")) ?? []

      if (hiddenOnMarket.includes(market) || (variant.id && hiddenVariants.includes(variant.id))) {
        return null
      }

      return variant
    }).filter(Boolean)

  return serializedVariants
}